export var QueryParameters;
(function (QueryParameters) {
    QueryParameters["CatalogType"] = "catalog-type";
    QueryParameters["NavigationSource"] = "navigationSource";
})(QueryParameters || (QueryParameters = {}));
export var CatalogType;
(function (CatalogType) {
    CatalogType["TopPicks"] = "top-picks";
    CatalogType["Brand"] = "brand";
    CatalogType["CrossCampaign"] = "cross-campaign";
    CatalogType["Campaign"] = "campaign";
})(CatalogType || (CatalogType = {}));
